import { Navigate, useParams } from "react-router-dom";

/**
 * Canvas page — redirects to Chat for now.
 * Canvas is a visual document creation mode built on top of the chat engine.
 */
export function Canvas() {
  const { sessionId } = useParams();
  return <Navigate to={sessionId ? `/chat/${sessionId}` : "/chat"} replace />;
}
